{
  // Refreshes all .attraction-status elements on the page via a single AJAX call,
  // bypassing page cache. Server-rendered content is the initial state.
  const els = [...document.querySelectorAll('.attraction-status[data-post-id]')]
  if (!els.length) return

  // If PHP rendered with preview data, data-preview-datetime is set — skip AJAX
  if (els.some(el => el.dataset.previewDatetime)) return

  const ids = [...new Set(els.map(el => el.dataset.postId))]
  const previewSchedule = new URLSearchParams(window.location.search).get('preview_schedule')
  const data = previewSchedule
    ? { action: 'post_status_label', ids, preview_schedule: previewSchedule }
    : { action: 'post_status_label', ids }
  window.coolHelperFunctions?.coolAjax(data, res => {
    if (!res?.data) return
    els.forEach(el => {
      const status = res.data[el.dataset.postId]
      if (status != null) el.innerHTML = status
    })
  })
}
